import { UserShortWithWork } from "tm-shared/types";

import { useLoadUserSchedule } from "@/pages/SV/Team/hooks/useLoadUserSchedule";

import { StyledActiveUserSection, StyledSectionTitle } from "../../Styled";
import { MemberCard } from "../MemberCard";

interface ActiveUserSectionProps {
    member: UserShortWithWork;
    routeId?: string;
    isProcessing: boolean;
    onLoadSchedule: ReturnType<
        typeof useLoadUserSchedule
    >["handleLoadUserSchedule"];
    onNavigate: () => void;
}

export const ActiveUserSection = ({
    member,
    routeId,
    isProcessing,
    onLoadSchedule,
    onNavigate,
}: ActiveUserSectionProps) => {
    return (
        <>
            <StyledSectionTitle>Активний маршрут</StyledSectionTitle>

            <StyledActiveUserSection>
                <MemberCard
                    member={member}
                    routeId={routeId}
                    isActive
                    isProcessing={isProcessing}
                    onLoadSchedule={onLoadSchedule}
                    onNavigate={onNavigate}
                />
            </StyledActiveUserSection>
        </>
    );
};
